export const formData = [
  {
    name: "name",
    label: "Name",
  },
  {
    name: "company",
    label: "Company Name",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
  },
  {
    name: "phoneNo",
    label: "Phone Number",
    type: "tel",
  },
  {
    name: "message",
    label: "Message",
    type: "textarea",
    rows: "7",
    // placeholder: "Type your message here",
  },
  {
    name: "button",
    label: "Send Message",
  },
];
